import styled from "styled-components";


export const SubjectWrapper = styled.div`
padding-top: 20px;
padding-bottom: 20px;
`
export const ToWrapper = styled.div`
    border-bottom: 1px solid rgba(0, 46, 92, 0.1);
    display: flex;
    justify-content: flex-start;
    padding-bottom: 10px;
    width: 90%;
    padding-top: 20px;
`